module.exports = __webpack_public_path__ + "static/img/technology_3.411e821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/technology_3.jpg
// module id = s2mP
// module chunks = 0